module.exports = __webpack_public_path__ + "static/media/trinity-norwood.3dab1628.md";